
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[recipe]",
      function () {
        return require("private-next-pages/[recipe].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[recipe]"])
      });
    }
  